import { useState } from 'react';

import { Notification, hasMissingRequiredTaskFields } from 'src/utils';
import { TaskStage } from 'src/interfaces/task';

import { IProps } from './actions.type';

const useTask = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [sending, setSending] = useState<boolean>(false);

  const updateStageTask = async (taskId: any, stage: TaskStage) => {
    try {
      const response = await props.updateStageTask(taskId, stage);

      return !!response;
    } catch (err: any) {
      Notification.error({
        message:
          'Ocorreu um erro ao carregar as tarefas, tente novamente mais tarde.',
      });

      return false;
    }
  };

  const handleUpdate = async (stage: TaskStage) => {
    const task = props.task;

    if (hasMissingRequiredTaskFields(task)) {
      Notification.warning({
        message:
          'Adicione os dados obrigatórios da OS antes de continuar o fluxo da tarefa.',
      });
      return false;
    }

    try {
      const response = await updateStageTask(task?.id, stage);

      if (response) {
        setSending(response);
        props.handleModal();
      }
    } finally {
      setSending(false);
    }
  };

  const handleDelete = async (id: string) => {};

  const handleRefresh = async () => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1000);
  };

  return {
    handleUpdate,
    handleDelete,
    sending,
    task: props.task,
    loading,
    setLoading,
    handleRefresh,
  };
};

export default useTask;
